import React from 'react';
import {Button, Box, ButtonGroup} from '@chakra-ui/react';
import {useAgentBuilderStore} from './AgentBuilder.state';
import {BuilderTitleSection} from './BuilderTitleSection';
import {WrapperFlex} from '../../utils/scrolling';
import {useModalContext} from '@chakra-ui/react';
import {UseMutationResult} from '@tanstack/react-query';

export const StepContainer = ({
  children,
  onSaveMutation,
  isSaveable = true,
}: {
  children: React.ReactNode;
  onSaveMutation?: UseMutationResult<unknown, Error, void, unknown>;
  isSaveable?: boolean;
}) => {
  const {serverState} = useAgentBuilderStore();
  const {onClose} = useModalContext();

  return (
    <>
      <BuilderTitleSection title="AI Agent Builder" label={serverState?.label}>
        <ButtonGroup>
          <Button color="kgray.300" onClick={onClose} variant="ghost">
            Exit
          </Button>
          <Button
            colorScheme="kbuttonblue"
            isDisabled={!isSaveable}
            isLoading={onSaveMutation?.isPending}
            variant="outline"
            onClick={async () => {
              if (!onSaveMutation) {
                onClose();
                return;
              }

              onSaveMutation.mutate(undefined, {
                onSuccess: onClose,
              });
            }}
          >
            {serverState?.status === 'published'
              ? 'Save & Exit'
              : 'Save Draft & Exit'}
          </Button>
        </ButtonGroup>
      </BuilderTitleSection>

      <Box flex="1" position="relative">
        <WrapperFlex>{children}</WrapperFlex>
      </Box>
    </>
  );
};
